import { render, staticRenderFns } from "./home.vue?vue&type=template&id=0c03b8d5&scoped=true&"
import script from "./home.vue?vue&type=script&lang=ts&"
export * from "./home.vue?vue&type=script&lang=ts&"
import style0 from "./home.vue?vue&type=style&index=0&id=0c03b8d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c03b8d5",
  null
  
)

component.options.__file = "home.vue"
export default component.exports